import React from 'react';
import styles from './SwitchButton.module.css';

const SwitchButton = ({ checked, onChange, disabled }) => {
    return (
        <div className={styles.index_switch}>
            <label className={styles.index_toggle_wrapper}>
                <input
                    type="checkbox"
                    className={styles.index_toggle_input}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                />
                <span className={styles.index_toggle_slider}></span>
            </label>
        </div>
    )
}

export default SwitchButton;